import React from "react";
import {Flex} from 'rebass'
import {CardList} from "./../List";

const cardList = [
   {
        card_title:"脳波解析ソフトウェア",
        card_text:"EEG x Python x ML",
        card_img:"/img/work_1.jpg",
        card_desc:"coming soon..."
   },
   {
        card_title:"新卒採用WEBサービス",
        card_text:"Web Platform x Laravel",
        card_img:"/img/work_2.jpg",
        card_desc:"coming soon..."
    },
    {
        card_title:"睡眠科学の目覚ましアラーム",
        card_text:"Sleep science x Android",
        card_img:"/img/work_3.jpg",
        card_desc:"coming soon..."
    },
    {
        card_title:"GPSを用いたSNSプラットフォーム",
        card_text:"Mobile app x Platform",
        card_img:"/img/work_4.jpg",
        card_desc:"coming soon..."
    },
    {
        card_title:"マルチモーダルロボット制御",
        card_text:"ML x Android",
        card_img:"/img/work_5.png",
        card_desc:"coming soon..."
    },
    {
        card_title:"画像認識サービス",
        card_text:"ML x Python",
        card_img:"/img/work_6.jpg",
        card_desc:"coming soon..."
    },
];

export default class Works extends React.Component {
    render() {
        return (
            <main>
            <Flex alignItems='space-around'
                flexWrap='wrap'
                justifyContent='space-around'
            >
                {cardList.map(item => (
                    <CardList
                        card_title={item.card_title}
                        card_text={item.card_text}
                        card_img={item.card_img}
                        card_desc={item.card_desc}
                    />
                ))}
            </Flex>
            </main>
        );
    }
}
